import appLinks from '../appLinks/config.json';
import { contentUrl } from '../appLinks/links';
import url from './url';
import { aboutDisplayText } from './aboutLinks';

const clean = (value, limit) => Array.from(String(value || '')
  // eslint-disable-next-line no-control-regex
  .replace(/[\u0000-\u001f\u007f\u200b-\u200f\u202a-\u202e\u2066-\u2069\ufeff]/g, ' ')
  .replace(/\s+/g, ' ').trim()).slice(0, limit).join('');

// Pass the persisted profile, never the biography editor's draft. Keep this
// synchronous so the original tap can open the system share sheet on iOS.
export function profileShare(user = {}) {
  const name = clean([user.first_name, user.last_name].filter(Boolean).join(' '), 120);
  const handle = clean(user.user_name, 100);
  const restricted = user.is_delete || ['quarantined', 'suspended'].includes(user.abuse_state);
  const target = user.user_name ? contentUrl(url(`/user/${encodeURIComponent(user.user_name)}`)) : null;
  const title = restricted ? 'WIW' : [name, handle && `@${handle}`].filter(Boolean).join(' · ') || 'WIW';
  const about = clean(aboutDisplayText(user.about), 200);
  return {
    shareTitle: title,
    shareText: restricted ? 'WIW' : [title, about].filter(Boolean).join('\n'),
    shareUrl: target || appLinks.origin,
    shareContext: { source: 'profile', targetType: 'profile', targetId: user.id },
  };
}
